import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

interface IStyleProps {
  isDisabled?: boolean
}

export const useStyles = makeStyles((theme: Theme) => ({
  addBtn: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: SPACES.xs,
    minWidth: 200,
    alignItems: 'center',

    [theme.breakpoints.down('tablet')]: {
      flexWrap: 'wrap',
      minWidth: 110,
      width: '100%',
      justifyContent: 'center',
    },
    marginTop: 40,
    marginBottom: 20,
  },

  addNewButtonWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      gap: SPACES.xs,
      alignItems: 'center',
      justifyContent: 'flex-end',

      [theme.breakpoints.down('mobile_l')]: {
        flexWrap: 'wrap-reverse',
        width: '75%',
        margin: '0px auto',
        justifyContent: 'center',
      },
    },
  },
  addNewButton: {
    '&&': {
      width: 150,
      height: 40,
      marginLeft: 'auto',

      boxShadow: `2px 4px 8px ${theme.palette.custom.grey}`,
      borderRadius: 20,

      fontWeight: FONTS.WEIGHTS.bold,
      color: 'white',

      fontSize: FONTS.SIZES.s,

      [theme.breakpoints.down('mobile_l')]: {
        flexWrap: 'wrap-reverse',
        width: '100%',
      },
    },
  },

  addNewCardWrapper: {
    '&&': {
      backgroundColor: theme.palette.custom.secondary,

      borderRadius: '10px',
      boxShadow: 'none',
    },
  },
  addNewCard: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '15px',

      width: 178,
      height: 178,
    },
  },

  addNewCardAction: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '&:disabled': {
        backgroundColor: theme.palette.custom.grey,
        '& p': {
          color: theme.palette.custom.grey2,
        },
        '& svg': {
          color: theme.palette.custom.grey2,
        },
      },
    },
  },

  addNewCardText: (props: IStyleProps) => ({
    '&&': {
      marginLeft: SPACES.xxxs,
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
      textTransform: 'uppercase',

      color: props.isDisabled ? theme.palette.custom.grey2 : theme.palette.custom.primary,
    },
  }),

  addNewCardTextSecondary: {
    '&&': {
      fontWeight: 500,
      fontSize: '11px',
      textAlign: 'center',

      color: theme.palette.custom.grey2,
    },
  },
}))
